export const formatDateForGroup = (dateString: string | undefined | null): string => {
  if (!dateString) return 'No Date';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'Invalid Date';

  // Format: "Sun, 29 Jan"
  return new Intl.DateTimeFormat('en-GB', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
  }).format(date);
};

export const groupItemsByDate = <T>(
  items: T[],
  getDate: (item: T) => string | undefined | null
): Record<string, T[]> => {
  const groups: Record<string, T[]> = {};

  items.forEach((item) => {
    const dateStr = getDate(item);
    // Standardize date string to YYYY-MM-DD for sorting/grouping keys
    // This assumes dateStr is parsable by Date constructor
    let key = 'No Date';
    if (dateStr) {
      const date = new Date(dateStr);
      if (!isNaN(date.getTime())) {
         key = date.toISOString().split('T')[0];
      }
    }

    if (!groups[key]) {
      groups[key] = [];
    }
    groups[key].push(item);
  });

  return groups;
};

type DateInputClickEvent = {
  isTrusted: boolean;
  currentTarget: HTMLInputElement;
};

type DateInputKeyboardEvent = {
  key: string;
  preventDefault: () => void;
};

type DateInputClipboardEvent = {
  preventDefault: () => void;
};

export const openNativeDatePickerSafely = (event: DateInputClickEvent): void => {
  if (!event.isTrusted) return;
  try {
    event.currentTarget.showPicker?.();
  } catch {
    return;
  }
};

export const preventManualDateEntry = (event: DateInputKeyboardEvent): void => {
  if (event.key === 'Tab') return;
  event.preventDefault();
};

export const preventManualDatePasteOrDrop = (event: DateInputClipboardEvent): void => {
  event.preventDefault();
};
